<div ng-controller="exportGeneralController as ctrl" class="service-details">
    <div class="modal-view">
        <c-auto-form config="ctrl.serviceConfig"></c-auto-form>
    </div>
</div>